export default "__VITE_ASSET__BbD3Y9dh__"